<script>
    export let value;
    export let label;
    export let name;
    export let min;
    export let max;
</script>

<label>
    {#if label}
        <span class="label">
            {label}
        </span>
    {/if}
    <input type="number" {name} bind:value={value} {min} {max}>
</label>

<style>
    label {
        margin-bottom: 1rem;
    }

    .label {
        display: block;
        margin-bottom: 0.2rem;
        font-size: 0.8rem;
    }

    input {
        display: block;
        border-radius: 0.5rem;
        border: 2px solid #F5F2EF;
    }
</style>